import usePagedList from "../../../hooks/usePagedList";
import * as crmApi from "../api/crmApi";
import { PAGE_SIZE } from "../contract";

/** The Clients list page for `query` (filters + sort), 50 per page (spec). */
export default function useCrmClients(query) {
  return usePagedList(crmApi.listClients, query, PAGE_SIZE);
}
